import { useMutation, useQuery } from '@tanstack/react-query';
import { Button, Form, Input, Select, message } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { useIntl } from 'react-intl';
import PhoneInputWithCountrySelect, {
  parsePhoneNumber,
} from 'react-phone-number-input';
import { listServicesCategories } from '../../../../network/service';
import { addLocation } from '../../../../network/settings';
import queryClient from '../../../../services/react-query/queryClient';
import { queryKeys } from '../../../../services/react-query/queryKeys';
import AddressLocation from './AddresLocation';
import EditWorkingsHours from './items/EditWorkingsHours';
const AddNewLocation = ({ cancel }: any) => {
  const [form] = Form.useForm();
  const [secPhone, setSecPhone] = useState(false);
  const [isEdit] = useState(true);
  const [value, setValue] = useState<any>();
  const [value2, setValue2] = useState<any>();
  const [newLatLng, setNewLatLng] = useState<any>({
    lat: 24.774265,
    lng: 46.738586,
  });
  const { locale } = useIntl();

  const [newLatLng2, setNewLatLng2] = useState<any>({
    lat: 24.774265,
    lng: 46.738586,
  });
  const [mapInfo, setMapInfo] = useState('');
  const [mapInfo2, setMapInfo2] = useState('');

  const {
    mutate: AddLocation,
    isLoading,
    error: addSalonError,
  } = useMutation(addLocation, {
    onSuccess: (res: any) => {
      if (
        res?.response?.status === 422 ||
        res?.response?.status === 500 ||
        res?.response?.status === 404 ||
        res?.code === 'ERR_BAD_REQUEST'
      ) {
        res?.response?.data?.message
          ? message.error(res?.response?.data?.message)
          : message.error(res?.response?.data?.error);
        console.log(res);
      } else {
        message.success('Location added successfully');
        queryClient.invalidateQueries([queryKeys.Locations]);
        cancel();
      }
    },
  });

  const { data: services } = useQuery([queryKeys?.listServicesOnboarind], () =>
    listServicesCategories({ is_parent: 1 })
  );
  const onFinish = (values: any) => {
    const phoneNumber = parsePhoneNumber(value || '');
    const phoneNumber2 = parsePhoneNumber(value2 || '');

    const opening_hours_array = Object.keys(values.opening_hours)?.map(
      (day) => ({
        day,
        opening_time: dayjs(values?.opening_hours[day]?.opening_time).format(
          'HH:mm'
        ),
        closing_time: dayjs(values?.opening_hours[day]?.closing_time).format(
          'HH:mm'
        ),
      })
    );
    AddLocation({
      ...values,
      contact_country_code: phoneNumber ? phoneNumber?.country : '', // Extracting the phone number from parsedPhoneNumber
      contact_number: phoneNumber ? phoneNumber?.nationalNumber : '',
      ...(phoneNumber2 &&
        phoneNumber2?.country && {
          additional_phone_country_code: phoneNumber2?.country,
        }),
      ...(phoneNumber2 &&
        phoneNumber2?.nationalNumber && {
          additional_phone: phoneNumber2?.nationalNumber,
        }),
      have_business_location: true,
      lat: newLatLng?.lat,
      lng: newLatLng?.lng,
      opening_hours: opening_hours_array,
      primary_service_categories: [values?.primary_service_categories],
      billing_information: {
        ...values?.billing_information,
        lat: newLatLng2?.lat,
        lng: newLatLng2?.lng,
      },
      invoice_note: ``,
    });
  };

  const [mainOptions, setMainOptions] = useState<any>([]);
  const [secondaryOptions, setSecondaryOptions] = useState<any>([]);
  useEffect(() => {
    if (services?.data) {
      const mainOpts = services?.data?.map((e: any) => {
        return {
          label: e?.name,
          value: e?.id,
        };
      });
      setMainOptions(mainOpts);
      setSecondaryOptions(mainOpts); // Set initial options for secondary select
    }
  }, [services?.data]);

  const handleMainBusinessTypeChange = (value: any) => {
    // Remove selected main option from secondary options
    const filteredSecondaryOptions = secondaryOptions.filter(
      (opt: any) => opt.value !== value
    );
    setSecondaryOptions(filteredSecondaryOptions);
  };

  const handleSecondaryBusinessTypeChange = (value: any) => {
    // Remove selected secondary option from main options
    const filteredMainOptions = mainOptions?.filter(
      (opt: any) => opt?.value !== value
    );
    setMainOptions(filteredMainOptions);
  };
  const intl = useIntl();
  return (
    <div>
      <div
        className="flex items-center gap-2 mb-6 cursor-pointer"
        onClick={() => cancel()}
      >
        {locale === 'ar' ? (
          <IoIosArrowForward className="text-[#9999A7] flex items-center my-auto" />
        ) : (
          <IoIosArrowBack className="text-[#9999A7] flex items-center my-auto" />
        )}{' '}
        <h5 className="text-base font-semibold">
          {intl.formatMessage({ id: 'addNewBranchTitle' })}
        </h5>
      </div>
      <Form
        name="EditSalonBranch"
        form={form}
        className="grid grid-cols-2 gap-4 max-md:grid-cols-1"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={(error) => console.log('onFinishFailed', error)}
      >
        <div className={` bg-white p-4 rounded-lg `}>
          <div className="mb-4 text-base">
            {intl.formatMessage({ id: 'branchContactInfoTitle' })}
          </div>
          <div className="flex items-center gap-4">
            <Form.Item
              name={['name', 'ar']} // Change "email" to "name"
              label={
                <div className="text-sm">
                  {intl.formatMessage({ id: 'branchNameLabelArabic' })}
                </div>
              }
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: 'branchNameRequiredErrorMessage',
                  }),
                },
                {
                  validator: (_, value) => {
                    if (!/^[ء-ي0-9 ]+$/.test(value)) {
                      // Regular expression for Arabic characters and numbers
                      return Promise.reject(
                        new Error(
                          intl.formatMessage({
                            id: `localization.Only[ar]`, // Adjust the localization key as necessary
                          })
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              className="w-full"
              required={false}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={['name', 'en']} // Change "email" to "name"
              label={
                <div className="text-sm">
                  {intl.formatMessage({ id: 'branchNameLabelEnglish' })}
                </div>
              }
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: 'branchNameRequiredErrorMessage',
                  }),
                },
                {
                  validator: (_, value) => {
                    if (!/^[A-Za-z0-9 ]+$/.test(value)) {
                      // Regular expression for English characters and numbers
                      return Promise.reject(
                        new Error(
                          intl.formatMessage({
                            id: `localization.Only[en]`, // Adjust the localization key as necessary
                          })
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              className="w-full"
              required={false}
            >
              <Input />
            </Form.Item>
          </div>
          <div className="flex items-center w-full gap-4 max-md:flex-col">
            <Form.Item
              name={'email'}
              label={
                <div className="text-sm">
                  {intl.formatMessage({ id: 'branchEmailLabel' })}
                </div>
              }
              rules={[{ type: 'email' }]}
              className="w-1/2 max-md:w-full"
            >
              <Input />
            </Form.Item>
            <div className="w-full">
              <div className="flex items-center w-full gap-2 max-md:flex-col">
                <Form.Item
                  label={
                    <div className="text-sm">
                      {intl.formatMessage({ id: 'primaryPhoneNumberLabel' })}
                    </div>
                  }
                  name="contact_number"
                  required={false}
                  className="w-full"
                >
                  <PhoneInputWithCountrySelect
                    defaultCountry="SA"
                    value={value}
                    onChange={setValue}
                    international
                    limitMaxLength={true}
                    className="!border-[1px] w-full !border-solid !border-color-primary !py-2 !px-[11px] !h-[42px]"
                  />
                </Form.Item>
                <Button
                  type="default"
                  className={`flex items-center justify-center gap-2 max-md:w-full ${
                    secPhone && 'hidden'
                  }`}
                  onClick={() => setSecPhone((e: any) => !e)}
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4141 2.3999H4.78906C4.20911 2.4006 3.65312 2.63129 3.24303 3.04137C2.83295 3.45146 2.60226 4.00745 2.60156 4.5874L2.60156 14.2124C2.60226 14.7923 2.83295 15.3483 3.24303 15.7584C3.65312 16.1685 4.20911 16.3992 4.78906 16.3999H14.4141C14.994 16.3992 15.55 16.1685 15.9601 15.7584C16.3702 15.3483 16.6009 14.7923 16.6016 14.2124V4.5874C16.6009 4.00745 16.3702 3.45146 15.9601 3.04137C15.55 2.63129 14.994 2.4006 14.4141 2.3999ZM15.7266 14.2124C15.7266 14.5605 15.5883 14.8943 15.3421 15.1405C15.096 15.3866 14.7622 15.5249 14.4141 15.5249H4.78906C4.44097 15.5249 4.10713 15.3866 3.86098 15.1405C3.61484 14.8943 3.47656 14.5605 3.47656 14.2124V4.5874C3.47656 4.23931 3.61484 3.90547 3.86098 3.65932C4.10713 3.41318 4.44097 3.2749 4.78906 3.2749H14.4141C14.7622 3.2749 15.096 3.41318 15.3421 3.65932C15.5883 3.90547 15.7266 4.23931 15.7266 4.5874V14.2124Z"
                      fill="#00086D"
                    />
                    <path
                      d="M9.89766 6.63037H9.29766V9.33037H6.59766V9.93037H9.29766V12.6304H9.89766V9.93037H12.5977V9.33037H9.89766V6.63037Z"
                      fill="#00086D"
                    />
                  </svg>
                  {intl.formatMessage({ id: 'additionalPhoneNumberLabel' })}
                </Button>
              </div>
              {secPhone && (
                <Form.Item
                  name="additional_phone"
                  required={false}
                  className=""
                >
                  <PhoneInputWithCountrySelect
                    defaultCountry="SA"
                    value={value2}
                    onChange={setValue2}
                    international
                    limitMaxLength={true}
                    className="!border-[1px] w-[99%] !border-solid !border-color-primary !py-2 !px-[11px] !h-[42px]"
                  />
                </Form.Item>
              )}
            </div>
          </div>
        </div>
        <div className={` bg-white p-4 rounded-lg`}>
          <div className="mb-4 text-base">
            {intl.formatMessage({ id: 'typeOfWork' })}
          </div>

          <div className="w-full">
            <Form.Item
              name={'primary_service_categories'}
              label={
                <div className="text-sm">
                  {intl.formatMessage({ id: 'mainBusinessTypeLabel' })}
                </div>
              }
              className="w-full"
              required={false}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({ id: 'mainServiceRequired' }),
                },
              ]}
            >
              <Select
                defaultValue=""
                onChange={handleMainBusinessTypeChange}
                options={mainOptions}
                className="w-full"
              />
            </Form.Item>
            <Form.Item
              name={'secondary_service_categories'}
              required={false}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: 'secondaryServiceRequired',
                  }),
                },
              ]}
              label={
                <div className="text-sm">
                  {intl.formatMessage({ id: 'secondaryBusinessTypeLabel' })}
                </div>
              }
            >
              <Select
                mode="multiple"
                style={{ width: '100%' }}
                defaultValue={[]}
                onChange={handleSecondaryBusinessTypeChange}
                optionLabelProp="label"
                options={secondaryOptions}
                maxLength={1}
                // optionRender={(option: any) => <div>{option.data.label}</div>}
              />
            </Form.Item>
          </div>
        </div>
        <AddressLocation
          setMapInfo={setMapInfo}
          mapInfo={mapInfo}
          setNewLatLng={setNewLatLng}
          newLatLng={newLatLng}
          isEdit={isEdit}
          label={intl.formatMessage({ id: 'business_location_label' })}
          name="business_location"
          business_location={{}}
          form={form}
        />
        <AddressLocation
          setMapInfo={setMapInfo2}
          mapInfo={mapInfo2}
          setNewLatLng={setNewLatLng2}
          newLatLng={newLatLng2}
          isEdit={isEdit}
          label={intl.formatMessage({ id: 'billing_information_label' })}
          name="billing_information"
          business_location={{}}
          form={form}
        />
        <EditWorkingsHours isEdit={isEdit} form={form} />
        <div className="flex items-center justify-end gap-4 md:col-span-2">
          <Button
            type="primary"
            htmlType="submit"
            className="min-w-[10rem] max-w-[10rem] "
            loading={isLoading}
          >
            {intl.formatMessage({ id: 'addBranchButtonLabel' })}
          </Button>
          <Button
            type="primary"
            className="min-w-[10rem] max-w-[10rem] btn-primary-not"
            onClick={() => cancel()}
          >
            {intl.formatMessage({ id: 'cancel' })}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddNewLocation;
